import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import PicButton from '../../../../../../../../../../components/pic-button/index';
import {flash, getSharingDetailsPopup} from '../../../../../../../../../../../actions/sharingDetailsActions';
import {msgBar} from '../../../../../../../../../../../actions/msgBarActions';

class BulkLabelsActions extends Component {

	constructor(props) {
		super(props);

		this.shareHandler = this.shareHandler.bind(this);
	}

	shareHandler(e) {

		if (e.currentTarget.dataset.disabled === 'false') {
			if (this.props.profile.status.includes('invited')) {
				this.props.getSharingDetailsPopup([true, 'choose_plan']);
			} else {
				this.props.getSharingDetailsPopup([true, 'add_user', 'severalLabels']);
			}

			this.props.setFlash([]);
		} else {
			e.currentTarget.style.cursor = 'not-allowed';
			setTimeout(() => {
				if (this.props.selectedContactsGroup.permission === 'WRITE_ONLY') {
					this.props.msgBar(['error', this.props.t('textErrorPermission1')])

				} else if (this.props.selectedContactsGroup.permission === 'WRITE_DELETE') {
					this.props.msgBar(['error', this.props.t('textErrorPermission2')])
				} else {
					this.props.msgBar(['error', this.props.t('msgBarErrorText5')])
				}
			}, 10)
		}
	}

	render() {
		if (this.props.profile && this.props.profile.role === 'RESTRICTED_USER') {
			return null;
		}
		return (
			<div className="d-flex align-items-center bulk-labels-actions pl-3 border-left h-100 text-nowrap">
				<div className="selected-labels">
					{this.props.selectSeveralContactsGroups.length}&nbsp;
					{ this.props.selectSeveralContactsGroups.length > 1 ? this.props.t('labelsSelected') : this.props.t('labelSelected') }
				</div>
				<div className="d-flex align-items-center ml-3 pl-2 border-left h-100">
					<PicButton onClick={this.shareHandler}
					           data-disabled={
						           this.props.findLabels.contactsGroups.length === 0
						           && this.props.selectedContactsGroup.id !== '6'
					           }
					           aria-disabled={this.props.findLabels.contactsGroups.length === 0}
					           className="d-flex align-items-center"
					>
						<svg width="16px" height="16px" viewBox="0 0 16 16">
							<line fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" x1="5.425"
							      y1="9.046" x2="10.575" y2="11.62"/>
							<line fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" x1="5.425"
							      y1="6.954" x2="10.575" y2="4.379"/>
							<path fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" d="M15,3.334c0,1.287-1.046,2.332-2.333,2.332
                                        s-2.334-1.045-2.334-2.332C10.333,2.046,11.38,1,12.667,1S15,2.046,15,3.334"/>
							<path fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" d="M15,12.667C15,13.954,13.954,15,12.667,15
                                        s-2.334-1.046-2.334-2.333s1.047-2.334,2.334-2.334S15,11.38,15,12.667"/>
							<path fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" d="M5.666,8c0,1.287-1.045,2.333-2.332,2.333
                                        C2.046,10.333,1,9.287,1,8s1.046-2.334,2.334-2.334C4.62,5.666,5.666,6.713,5.666,8"/>
						</svg>
					</PicButton>
					{/*<PicButton disabled={this.props.findLabels.contactsGroups.length === 0} id="shareContacts"
					           className="d-flex align-items-center">
						<Icon name="trash"/>
					</PicButton>*/}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		findLabels: state.contactsGroupItemReducer.findLabels,
		profile: state.profileReducer.getProfile,
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
		selectSeveralContactsGroups: state.contactsGroupItemReducer.selectSeveralContactsGroups,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getSharingDetailsPopup: (array) => {
			dispatch(getSharingDetailsPopup(array))
		},
		msgBar: (array) => {
			dispatch(msgBar(array))
		},
		setFlash: (array) => {
			dispatch(flash(array))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BulkLabelsActions));
